// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1oPq-","modalFooterButton":"ModalNotes_modalFooterButton__-t9-O"};